import { parseCookie } from "../services/parseCookie";

/**
 * Helper function that is used for fetching data from BE
 */

const fetchData = (url, options) => {
  const defaultOptions = {
    credentials: "include",
    headers: {
      Authorization: `JWT ${parseCookie("jwt")}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };

  return fetch(url, {
    ...options,
    ...defaultOptions
  });
};

export default fetchData;
